/**
* Equal Height Columns
*
* @desc create equal height columns
* @param object - the elements to apply equal heights to
* @return none
*/
export var equalHeights = function equalHeights(selector) {
  var $ = jQuery;

  if ($(selector).length <= 0) {
    return false;
  } else {
    $(selector).css('height', 'auto');
  }

  var el = selector;
  var newHeight = '';
  var colHeights = [];
  $(el).each(function () {
    var singleCol = $(this).outerHeight(); // Get the outerHeight of a single column

    colHeights.push(singleCol); // Push the single height into the array

    newHeight = Math.max.apply(Math, colHeights); // Get the tallest column from the array
  });
  $(el).css('height', newHeight + 'px'); // Apply the tallest height to all columns

  return true;
};